import { render, staticRenderFns } from "./WarehousesLoad.vue?vue&type=template&id=2edfa9c4&"
import script from "./WarehousesLoad.vue?vue&type=script&lang=js&"
export * from "./WarehousesLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports